const submitForm = (form: HTMLFormElement): void => {
    const optionCheckboxes = form.querySelectorAll('input');

    optionCheckboxes.forEach(option => {
        option.onclick = (): void => {
            if (!option.name.endsWith('[]')) {
                optionCheckboxes.forEach(opt => {
                    if (opt !== option) {
                        opt.removeAttribute('checked');
                    }
                });
            }
            form.submit();
        };
    });
};

const handleClicks = (form: HTMLFormElement): void => {
    form.querySelectorAll('label').forEach(label => {
        const checkbox = label.querySelector('input');
        if (!checkbox) {
            return;
        }

        label.onclick = (event): void => {
            event.preventDefault();
            event.stopPropagation();
            checkbox.click();
            label.setAttribute('aria-checked', checkbox.checked ? 'true' : 'false');
        };
        label.onkeyup = (event): void => {
            if (event.target === label && (event.key === 'Enter' || event.key === ' ')) {
                event.preventDefault();
                event.stopPropagation();
                checkbox.click();
                label.setAttribute('aria-checked', checkbox.checked ? 'true' : 'false');
            }
        };
    });
};

const handleShowMoreBtnClick = (form: HTMLFormElement): void => {
    const options: HTMLLIElement[] = Array.from(form.querySelectorAll('li'));
    const firstHiddenOption = form.querySelector('li.hidden input') as HTMLInputElement;
    const showMoreBtn: HTMLButtonElement | null = form.querySelector('.show-more-btn');

    if (showMoreBtn) {
        showMoreBtn.onclick = (event): void => {
            event.preventDefault();
            event.stopPropagation();

            options.forEach(option => {
                option.classList.remove('hidden');
            });

            showMoreBtn.classList.add('hidden');
            firstHiddenOption.focus();
        };
    }
};

export default function initFilterButtons(): void {
    const filtersForm: HTMLFormElement[] = Array.from(document.querySelectorAll('.filter-buttons form'));

    filtersForm.forEach((form) => {
        handleClicks(form);
        handleShowMoreBtnClick(form);
        submitForm(form);
    });
}
